(function (angular) {
    'use strict';

    angular.module('app')
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
        .filter('objLength', objLength);

    function objLength() {
        return function (object: {}) {
            return Object.keys(object).length;
        };
    }
}(angular));
